import { Reveal } from "./Reveal";

const chapters = [
  {
    no: "01",
    title: "Masalahnya bukan usaha Anda.",
    body: "Banyak orang bekerja lebih keras setiap tahun, namun hasilnya begitu-begitu saja. Yang membatasi bukan kemampuan — melainkan program bawah sadar tentang uang yang terbentuk sejak lama. Program yang tepat dapat menulis ulang program tersebut.",
  },
  {
    no: "02",
    title: "Perubahan besar dimulai dari keputusan kecil.",
    body: "Anda tidak perlu revolusi hidup dalam semalam. Anda hanya perlu satu langkah pertama yang benar: materi yang terbukti, bimbingan yang terstruktur, dan komitmen beberapa menit setiap hari.",
  },
  {
    no: "03",
    title: "Kami hanya memilih yang terbaik.",
    body: "Setiap produk di katalog ini kami kurasi dengan ketat. Pembelian Anda diproses langsung oleh platform resmi dengan payment gateway yang aman — tanpa perantara, tanpa kerumitan.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-24 md:py-32 bg-[#FBF7EE]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">Manifesto</p>
        <h2 className="font-display tracking-tighter text-3xl md:text-5xl max-w-2xl leading-tight mb-20">
          Tiga keyakinan yang menjadi fondasi katalog ini.
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-12 md:gap-16">
        {chapters.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.15} className="border-t border-[#211B10]/15 pt-8">
            <span className="font-mono text-sm text-[#A67C1E]">{c.no}</span>
            <h3 className="font-display text-2xl md:text-3xl tracking-tight mt-4 mb-5 leading-snug">{c.title}</h3>
            <p className="text-sm md:text-base text-[#211B10]/60 leading-relaxed">{c.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
